import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,[_c(VRow,[_c(VCol)],1),_c(VRow,{attrs:{"justify":"space-around"}},[_c(VCol,[_c(VCard,{attrs:{"elevation":"9"}},[_c(VCardText,[_c(VRow,[_c(VCol,[_c('span',{staticStyle:{"font-weight":"bold","color":"black","font-size":"16pt"}},[_vm._v(" به پنل کاربری Goldware خوش آمدید. ")])])],1),_c(VRow,[_c(VCol,[_c('span',[_vm._v(" کاربر گرامی این پنل برای دسترسی به دستگاه ها از طریق وب طراحی و پیاده سازی شده است در صورت وجود هرگونه مشکل در کارکرد با پشتیبانی در تماس باشید. ")])])],1)],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }